import store from '@/store'

let guard = () => new Promise((resolve, reject) => {
  return (store.getters['auth/user'].password_changed) ? resolve() : reject({
    name: 'change-password'
  })
})

export default {
  name: 'password-set',
  run: guard
}
